  const  languageConstants={
           en:{
            search:"Search",
            searchInputPlaceholder:"what movie do you want to see?",

           },
           bangla:{
            search:"অনুসন্ধান করুন",
            searchInputPlaceholder:"আপনি কোন সিনেমা দেখতে চান?",
           },
           chinese:{
            search:"搜索",
            searchInputPlaceholder:"你想看什么电影？",

           }           

}
export default languageConstants